import type {
  PlayersResponseDto,
  PlayersSduiResponseDto,
  SearchOptionsResponseDto,
} from '@nomiss/sdk';
import {
  PlayersResponseDtoFromJSON,
  PlayersSduiResponseDtoFromJSON,
} from '@nomiss/sdk';
import {
  executeSdkEnvelopeRequest,
  executeSdkRawRequest,
} from './api-request.util';
import { playersApi } from './sdk-client';

export async function getPlayersByTeamCodes(
  teamCodes: string[],
): Promise<PlayersResponseDto> {
  return executeSdkEnvelopeRequest({
    request: () =>
      playersApi.playersControllerGetPlayersByTeamCodesV1Raw({ teamCodes }),
    parse: PlayersResponseDtoFromJSON,
    fallback: 'Failed to load players',
  });
}

export async function getPlayersSdui(
  sportCode: string,
  teamCodes: string[],
): Promise<PlayersSduiResponseDto> {
  return executeSdkEnvelopeRequest({
    request: () =>
      playersApi.playersControllerGetPlayersSduiV1Raw({
        sportCode,
        teamCodes,
      }),
    parse: PlayersSduiResponseDtoFromJSON,
    fallback: 'Failed to load players SDUI',
  });
}

export type SearchPlayersParams = {
  sportCode: string;
  query?: string;
  cursor?: string;
  limit?: number;
  teamCodes?: string;
};

export async function searchPlayers(
  params: SearchPlayersParams,
): Promise<SearchOptionsResponseDto> {
  return executeSdkRawRequest<SearchOptionsResponseDto>({
    request: () =>
      playersApi.playersControllerSearchPlayersV1Raw({
        sportCode: params.sportCode,
        query: params.query,
        cursor: params.cursor,
        limit: params.limit,
        teamCodes: params.teamCodes,
      }),
    fallback: 'Failed to search players',
  });
}
